/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetaTracking
 */
export interface MetaTracking {
    /**
     * 
     * @type {string}
     * @memberof MetaTracking
     */
    clickId?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaTracking
     */
    pixelId?: string;
}

/**
 * Check if a given object implements the MetaTracking interface.
 */
export function instanceOfMetaTracking(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetaTrackingFromJSON(json: any): MetaTracking {
    return MetaTrackingFromJSONTyped(json, false);
}

export function MetaTrackingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaTracking {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clickId': !exists(json, 'clickId') ? undefined : json['clickId'],
        'pixelId': !exists(json, 'pixelId') ? undefined : json['pixelId'],
    };
}

export function MetaTrackingToJSON(value?: MetaTracking | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clickId': value.clickId,
        'pixelId': value.pixelId,
    };
}

